const persianDigits = "۰۱۲۳۴۵۶۷۸۹"
const arabicDigits = "٠١٢٣٤٥٦٧٨٩"

export const normalizeDigits = (value) =>
  String(value ?? "")
    .replace(/[۰-۹]/g, digit => String(persianDigits.indexOf(digit)))
    .replace(/[٠-٩]/g, digit => String(arabicDigits.indexOf(digit)))

export const normalizeIntegerInput = (value) =>
  normalizeDigits(value).replace(/[^0-9]/g, "")

export const normalizePhoneNumber = (value) => {
  let normalized = normalizeDigits(value).replace(/[\s\-()]/g, "")

  if (normalized.startsWith("0098")) normalized = `0${normalized.slice(4)}`
  else if (normalized.startsWith("+98")) normalized = `0${normalized.slice(3)}`

  return normalized
}

export const toNullableInteger = (value) => {
  const normalized = normalizeIntegerInput(value)

  return normalized ? Number(normalized) : null
}
